import { AnalyticsEvent } from "@/services/tracking/types/analyticsEvent";

import EventDataLayer, { SubscriberCallback } from "../../queue/EventDataLayer";
import { processAidenOrderConfirmation } from "./mappers/AidenOrderConfirmationImpression";

const AidenSubscriber = (
    eventDataLayer: EventDataLayer,
    withHistory = false
) => {
    eventDataLayer.subscribe("aiden-subscriber", subscribe, withHistory);
};

const subscribe: SubscriberCallback = (
    event: string,
    data: AnalyticsEvent
): void => {
    switch (event) {
        case "tool-laststep":
            processAidenOrderConfirmation(data);
            break;
    }
};

export { AidenSubscriber };
